import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicProduct from "@/pages/PublicProduct";
import { Spinner } from "@/components/Spinner";

const AdminApp = lazy(() => import("@/pages/admin/AdminApp"));

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Spinner full />}>
        <Routes>
          <Route path="/v" element={<PublicProduct />} />
          <Route path="/*" element={<AdminApp />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
